<template>
  <v-container fill-height fluid style="background:#FFA500" >

      <v-btn icon @click='test()'>
          <v-icon color="black">add_circle</v-icon>
      </v-btn>

    <v-slide-y-transition mode="out-in">
        <v-layout row wrap align-center>
            <v-layout column align-center>
                <img src="@/assets/splash.png" alt="Vuetify.js" class="mb-5">
                <blockquote class="mt-9">
                    Quickly Capture, Explore and Share visual surveys to keep your team informed.
                </blockquote>
            </v-layout>
        </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>

    import { callcloudfunction, nowmonth, checkcache } from '@/functions.js';

    export default {
        mounted: function () {
            this.$store.state.currentmonth = nowmonth();
            this.$store.state.heading = "";
            checkcache();
        },
        methods: {
            test() {
                callcloudfunction("checkInvites", "", { email: "mary.brown@missionalert.co.uk", id:"anClAVwNGAhoCe2owu10LG1X8sm2" }, this, "");  
                //callcloudfunction("checkTag", "full", { tagletters: "MB02" }, this, "");  
                //callcloudfunction("sendMail", "welcome", { name: "Mary", email: "mary.brown@missionalert.co.uk" }, this.$store, "");
            },
            cloudReturn(v) {
                this.$root.alertm('Alert', "Message " + v, { color: '#FFA500' }).then((confirm) => {
                    alert("XXX");
                })
            }
        }
    }
</script>

<style scoped>
    h1, h2 {
        font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
